module.exports = __webpack_public_path__ + "img/hakurei shrine.f12b0d64.png";